/** @file exportPuppet: downloads a puppet's export zip and reports a failure as a toast. */
import type { ExportQuery } from '@zilo/pose3d-api/types/restAdded';
import type { EditorStore } from '../state/editorTypes';
import { asPose3DError } from '../store/asPose3DError';
import type { EditorApi } from '../store/editorApi';
import { errorText } from '../store/errorText';
import { downloadBundle } from './downloadBundle';

/** The runtime bundle (no query) or whatever `query` asks for, saved as a file; errors become an error toast. */
export function exportPuppet(store: EditorStore, api: EditorApi | null, puppetId: string, name: string, query?: ExportQuery): void {
  if (api === null) return;
  downloadBundle(api, puppetId, name, query).catch((e: unknown) => { store.getState().notify('error', errorText(asPose3DError(e))); });
}
